import {Box,FormLabel, Select, InputGroup, InputRightElement, Input, useToast,SkeletonCircle, SkeletonText} from '@chakra-ui/react';
import { MdLocationOn, MdPerson } from 'react-icons/md';
import { useState,useEffect } from 'react';
import { getKnjige } from '../../util/apiKnjiga';

export default function KnjigaSelect({onKnjigaChange,readonly=false,preselectedKnjiga=0,size='xs',minimalView=false}) {
    const [knjige, setKnjige] = useState([]);
    const [selectedKnjigaId, setSlectedKnjigaId] = useState(-1);
    const [selectedKnjiga, setSlectedKnjiga] = useState({});
    const [dataisloading, setDataIsLoading] = useState(true);
    const toast=useToast();
    //const knjigeRef=useRef(null);

    const fetchData=async()=>{
        try {
                
            
            const resKnj=await getKnjige();
            
            
            if (resKnj.status===200) {
                
                    //setOdlazak({...odlazak,knjige:resKnj.res,dokumentTipovi:_dokumenttipovi,odlazakData:{...odlazak.odlazakData,knjiga_id:resKnj.res[0].id,lokacija:resKnj.res[0].lokacija, posjednik_naziv:resKnj.res[0].posjednik_naziv,vlasnik_naziv:resKnj.res[0].vlasnik_naziv,dokument_tip_id:_dokumenttipovi[0].dokument_tip_id,odjeljak_id:resKnj.res[0].odjeljak_id}});            
                    setKnjige(resKnj.res);
                    let _i=preselectedKnjiga;
                    if (_i===0) {
                        _i=resKnj.res[0].id;
                    }
                    setSlectedKnjigaId(_i);
                    showSelectedKnjiga(resKnj.res,_i);
                    onKnjigaChange(_i);
                    

                
            } else {
                throw new Error(resKnj.message);
            }
            
        } catch (error) {
            toast({
                title:"Greška kod dohvata podataka.",
                status:"error",
                description:error.message,
                isClosable:true,
                duration:2000,
                position:"top-right",
            });
        } finally {
            setDataIsLoading(false);
            
        }
        
    }
    
    useEffect(() => {
      fetchData();
     
       /*if (preselectedKnjiga!==0) {
         showSelectedKnjiga(knjige,preselectedKnjiga);
     } */
      /*if (knjigeRef.current) {
        knjigeRef.current.focus();  
      }*/
      
    },[])

    const onKnjigaSelectChange=(event)=>{
        
        onKnjigaChange(event.target.value);
        setSlectedKnjigaId(event.target.value);
        showSelectedKnjiga(knjige,event.target.value);
    }

    const showSelectedKnjiga=(knjige,id)=>{
        const _knjiga=knjige.filter(item=>item.id.toString()===id.toString());
        if (_knjiga.length===1) {
            setSlectedKnjiga({knjiga_id:_knjiga[0].id,lokacija:_knjiga[0].lokacija,
                odjeljak_id:_knjiga[0].odjeljak_id,posjednik_naziv:_knjiga[0].posjednik_naziv,vlasnik_naziv:_knjiga[0].vlasnik_naziv})
            
        }
    }

    const showSelectKnjige=()=>{
        if (dataisloading) {
            return (
    
                <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%'>
                    <SkeletonCircle size='10' />
                    <SkeletonText mt='4' noOfLines={10} spacing='4' skeletonHeight='2' />
                </Box>
            )
        } else {
            return (
                <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w={'100%'}>
                    <Box display={'flex'} flexDir={'row'} gap={'0.5rem'} w={'100%'}>
                        <Box w={'50%'}>
                            <FormLabel fontSize={size}>Knjiga (farma)</FormLabel>
                            <Select focusBorderColor='grunt2.400' size={size} isDisabled={readonly} variant={'filled'} defaultValue={selectedKnjigaId} maxLength={50} onChange={onKnjigaSelectChange} /*ref={knjigeRef}*/ id='slctKnjiga' value={selectedKnjigaId}>
                            {Array.isArray(knjige)?knjige.map((item,i)=>{
                                    return (<option key={i} value={item.id}>{item.naziv}</option>)
                            }):""}
                            </Select>
                        </Box>
                        <Box w={'50%'}>
                            <FormLabel fontSize={size}>Lokacija farme</FormLabel>
                                <InputGroup size={size}>
                                    <InputRightElement pointerEvents={'none'} children={<MdLocationOn/>}/>
                                    <Input focusBorderColor='grunt2.400' size={size} tabIndex={-1} variant={'outline'} isReadOnly placeholder='Lokacija' value={selectedKnjiga.lokacija} display={'block'}/>
                                </InputGroup>
                        </Box>
                    </Box>
                    {minimalView===false?
                    <Box display={'flex'} flexDir={'row'} gap={'0.5rem'} w={'100%'}>
                        <Box  w={'50%'}>
                            <FormLabel fontSize={size}>Posjednik</FormLabel>
                            <InputGroup size={size}>
                                <InputRightElement pointerEvents={'none'} children={<MdPerson/>}/>
                                <Input focusBorderColor='grunt2.400' size={size} tabIndex={-1} variant={'outline'} isReadOnly placeholder='Posjednik' value={selectedKnjiga.posjednik_naziv} display={'block'}/>
                            </InputGroup>
                        </Box>
                        
                        <Box w={'50%'}>
                            <FormLabel fontSize={'xs'}>Vlasnik</FormLabel>
                            <InputGroup size={size}>
                                <InputRightElement pointerEvents={'none'} children={<MdPerson/>}/>
                                <Input focusBorderColor='grunt2.400' size={size} tabIndex={-1} variant={'outline'} isReadOnly placeholder='Vlasnik' value={selectedKnjiga.vlasnik_naziv} display={'block'}/>
                            </InputGroup>
                        </Box>
                    </Box>
                    : null
                    }
                </Box>
            )
        }
    }

    return (
        <>{showSelectKnjige()}</>
        
    )
    

}
